import immutable from 'immutable';
import ConstValues from 'utils/const';
import {SearchIcon} from '@components/icon/SearchIcon';
import {PhoneOutIcon} from '@components/icon/PhoneOutIcon';
import {PhoneInIcon} from '@components/icon/PhoneInIcon';
import {HashtagIcon} from '@components/icon/HashtagIcon';
import {LargeBuildingIcon} from '@components/icon/LargeBuildingIcon';
import {MegaphoneIcon} from '@components/icon/MegaphoneIcon';
import {MessagePenIcon} from '@components/icon/MessagePenIcon';
import {TagIcon} from '@components/icon/TagIcon';

export const SEARCH_TYPE_MENU_ITEMS = new immutable.List([
  {
    primaryText: ConstValues.searchTypes.miAll,
    divClassName: 'search-type-all',
    tooltip: `Search ${ConstValues.searchTypes.miAll}`,
    icon: SearchIcon,
  },
  {
    primaryText: ConstValues.searchTypes.miCaller,
    divClassName: 'search-type-caller',
    tooltip: `Search ${ConstValues.searchTypes.miCaller}`,
    icon: PhoneOutIcon,
  },
  {
    primaryText: ConstValues.searchTypes.miContact,
    divClassName: 'search-type-contact',
    tooltip: `Search ${ConstValues.searchTypes.miContact}`,
    icon: PhoneInIcon,
  },
  {
    primaryText: ConstValues.searchTypes.miPhone,
    divClassName: 'search-type-phone',
    tooltip: `Search ${ConstValues.searchTypes.miPhone}`,
    icon: HashtagIcon,
  },
  {
    primaryText: ConstValues.searchTypes.miCompany,
    divClassName: 'search-type-company',
    tooltip: `Search ${ConstValues.searchTypes.miCompany}`,
    icon: LargeBuildingIcon,
  },
  {
    primaryText: ConstValues.searchTypes.miCampaign,
    divClassName: 'search-type-campaign',
    tooltip: `Search ${ConstValues.searchTypes.miCampaign}`,
    icon: MegaphoneIcon,
  },
  {
    primaryText: ConstValues.searchTypes.miKeywords,
    divClassName: 'search-type-keywords',
    tooltip: `Search Transcript and Keywords`,
    icon: TagIcon,
  },
  {
    primaryText: ConstValues.searchTypes.miAnnotations,
    divClassName: 'search-type-annotation',
    tooltip: `Search Comments and Highlights`,
    icon: MessagePenIcon,
  },
]);
